<template>
  <a-dropdown class="entry-menus" placement="bottomCenter">
    <span class="entry-menus__name" v-if="menu">
      {{ menu | menuLocalName }}
      <a-icon type="caret-down" style="margin-left:5px;font-size:12px" />
    </span>
    <div slot="overlay">
      <div class="entry-menus__custom" style="display:none">
        <div class="entry-menus__label">常用菜单：</div>
        <div class="entry-menus__value">
          <a-button shape="round" size="small">测试数据</a-button>
          <a-button shape="round" size="small">测试数据</a-button>
          <a-button shape="round" size="small">测试数据</a-button>
          <a-button shape="round" size="small">测试数据</a-button>
          <a-button shape="round" size="small">测试数据</a-button>
        </div>
      </div>
      <entry-menus-item :menu="menu" :currentLang="currentLang" @click="handleClick" @pushpin="handlePushpin" />
    </div>
  </a-dropdown>
</template>

<script>
import EntryMenusItem from './EntryMenusItem'

export default {
  name: 'EntryMenus',
  props: {
    menu: {
      type: Object,
      default () {
        return {}
      }
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  components: {
    EntryMenusItem
  },
  methods: {
    handleClick (key) {
      this.$emit('click', key)
    },
    handlePushpin (e) {
      this.$emit('pushpin', e)
    }
  }
}
</script>

<style lang="less">
.entry-menus__name {
  padding: 0 14px;
  display: block;
  height: 42px;
  color: #ffffff;
  font-size: 14px;
  line-height: 42px;
  overflow: hidden;
  position: relative;

  &.ant-dropdown-open {
    background: #5681F4;
    background: rgba(255, 255, 255, 0.25);

    &::after {
      content: " ";
      display: block;
      width: 8.48528137px;
      height: 8.48528137px;
      background: #ffffff;
      border-style: solid;
      border-width: 4.24264069px;
      position: absolute;
      left: 50%;
      bottom: -4px;
      transform: translateX(-50%) rotate(45deg);
    }
  }
}

a.entry-menus__name {
  &,
  &:hover,
  &:active {
    color: #ffffff;
  }
}

.entry-menus__custom {
  padding: 8px 10px 15px;
  background: #FAFAFA;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;

  .ant-btn {
    margin-right: 8px;
  }
}

.entry-menus__label {
  float: left;
}

.entry-menus__value {
  overflow: hidden;
}
</style>
